<template>
    <div class="work-orders-vendor-manager">
        <router-view name="default"></router-view>
        <router-view name="vendors"></router-view>
    </div>
</template>

<script>
    import VendorManagerEventBus from './vendor-manager-event-bus.vue';

    export default {
        name: 'WorkOrdersVendorManager',
        mounted() {
            VendorManagerEventBus.$on('api-request-error', errorMessage => {
                this.errorToast({text: errorMessage})
            });
        },
    };
</script>

<style lang="scss" scoped>
    .work-orders-vendor-manager {
        height: 100%;
    }
</style>
